import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgModule } from '@angular/core';
import { ErrorFormComponent } from '@mnz-shared/components/error-form/error-form.component';
import { ErrorInputComponent } from '@mnz-shared/components/error-input/error-input.component';
import { InlineSvgDirective } from '@mnz-shared/directives/inline-svg.directive';
import { LowercaseDirective } from '@mnz-shared/directives/lowercase.directive';
import { Relay42Directive } from '@mnz-shared/directives/relay42.directive';
import { TruncatePipe } from '@mnz-shared/pipes/truncate.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { MessageRendererComponent } from './components/messageRenderer/messageRenderer.component';
import { MessageStoreConnectorComponent } from './components/messageStoreConnector/messageStoreConnector.component';

const directives = [Relay42Directive, LowercaseDirective, InlineSvgDirective];
const pipes = [TruncatePipe];
const components = [ErrorInputComponent, ErrorFormComponent, MessageRendererComponent, MessageStoreConnectorComponent];

@NgModule({
  declarations: [...components, ...directives, ...pipes],
  imports: [CommonModule, TranslateModule.forChild()],
  exports: [...components, ...directives, ...pipes],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
